<template>
    <div class="p-4">
        <SubscriptionsIndex></SubscriptionsIndex>
    </div>
</template>

<script>
import SubscriptionsIndex from "@mobile/components/subscriptions/Manager";

export default {
    components: {SubscriptionsIndex},
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
